// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ApplicationController from "./application_controller"
application.register("application", ApplicationController)

import ArrayFieldController from "./array_field_controller"
application.register("array-field", ArrayFieldController)

import CopySubmitController from "./copy_submit_controller"
application.register("copy-submit", CopySubmitController)

import DisableController from "./disable_controller"
application.register("disable", DisableController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ExpandableRowController from "./expandable_row_controller"
application.register("expandable-row", ExpandableRowController)

import FilterSelectionController from "./filter_selection_controller"
application.register("filter-selection", FilterSelectionController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MultiSelectController from "./multi_select_controller"
application.register("multi-select", MultiSelectController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import Notifly__MessageController from "./notifly/message_controller"
application.register("notifly--message", Notifly__MessageController)

import RadioButtonToggleVisibilityController from "./radio_button_toggle_visibility_controller"
application.register("radio-button-toggle-visibility", RadioButtonToggleVisibilityController)

import TableSelectionController from "./table_selection_controller"
application.register("table-selection", TableSelectionController)

import TagController from "./tag_controller"
application.register("tag", TagController)

import TagSelectController from "./tag_select_controller"
application.register("tag-select", TagSelectController)

import TemplatableController from "./templatable_controller"
application.register("templatable", TemplatableController)

import TemplateSelectController from "./template_select_controller"
application.register("template-select", TemplateSelectController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)
